<template>
  <div>
    <ccHxpCensus />
  </div>
</template>

<script>
// 获取接口地址
import ccHxpCensus from '@/components/tjbb/ccHxpCensus.vue'

export default {
  name: 'Cchxpcrksj',
  components: {
    // sideMenu,
    // Header,
    ccHxpCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
